import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertController, ModalController } from '@ionic/angular';
import { AppEnum } from 'src/app/appenum';
import { AppService } from 'src/app/services/app.service';
import { CustomTextareaComponent } from '../custom-textarea/custom-textarea.component';
import { PreInspectionReportComponent } from '../pre-inspection-report/pre-inspection-report.component';
import { tempDynamicStoreconfig } from '../tempDynamicStoreconfig';
import { AppSettings } from 'src/app/app.settings';
import { TranslateService } from '@ngx-translate/core';
import { CustomTablevalComponent } from '../custom-tableval/custom-tableval.component';
import { EncryptionService } from 'src/app/services/encryption.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-taskchecklist',
  templateUrl: './taskchecklist.component.html',
  styleUrls: ['./taskchecklist.component.scss'],
  standalone: false
})
export class TaskchecklistComponent implements OnInit {
  public formFieldsJson: any = [];
  @Input() customTaskChecklist: any;
  @Input() PageName: string;
  @Output() _customFormValues1 = new EventEmitter();
  @Input() hiddenSubmitButton = false;
  @Input() submitEvent: any;
  @Input() taskDetails: any;
  public zoneKeys: any = [];
  public componentName = 'custom-dynamic-form-builder'
  public _customForm: UntypedFormGroup = new UntypedFormGroup({});
  count = 1;
  public valueChangeSub;
  public downloadFile = false;
  public previewFile = false;
  public ifConnected: any;
  public datalist = [];
  public dataFromAPI;
  public lat;
  public long;
  public fileList;
  value: string;
  lastKey: any;
  tableRowvalue: any;
  fileobj: any;
  deleteRowMsg: any;
  confirmText: any;
  cancelText: any;
  yesText: any;
  constructor(private _formBuilder: UntypedFormBuilder,
    public _appenum: AppEnum,
    public _tempDynamicStoreconfig: tempDynamicStoreconfig,
    public modalCtrl: ModalController,
    public _alertController: AlertController,
    public _appSetting: AppSettings,
    public _translateService: TranslateService,
    public _appServices: AppService,
    public encryptionService: EncryptionService) {
    this.deleteRowMsg = this._translateService.instant('common_text.delete_row_text');
    this.confirmText = this._translateService.instant('common_alert_text.confirm_title_text');
    this.cancelText = this._translateService.instant('common_btn_text.cancel_btn');
    this.yesText = this._translateService.instant('common_btn_text.yes_btn');
  }

  ngOnInit(): void {
    // document.getElementById("content").scrollIntoView();
    this.formFieldsJson = [];
    this._customForm = this._formBuilder.group({});
    this.formFieldsJson = this.customTaskChecklist;
    for (var i = new Date().getFullYear(); i >= 1900; i--) {
      this.datalist.push({ id: i, option: i });
    }
    if (this.taskDetails.TaskId) {
      this.getCustomerDataByDocID(this.taskDetails.TaskId);
    }
    this._formRender();
  }


  _formAddValue() {
    this.formFieldsJson.forEach((field: any) => {
      if (this.taskDetails.TaskId && !field['controlvalue'] && field.hasOwnProperty('controlvalueKey')) {
        if (this.dataFromAPI.hasOwnProperty(field['controlvalueKey'])) {
          this._customForm.controls[field['controlName']].setValue(this.dataFromAPI[field['controlvalueKey']]);
        }
        if (this.dataFromAPI['additionalInfo'] && this.dataFromAPI['additionalInfo'][0].hasOwnProperty(field['controlvalueKey'])) {
          this._customForm.controls[field['controlName']].setValue(this.dataFromAPI['additionalInfo'][0][field['controlvalueKey']]);
        }
      }
    });
    // this.formFieldsJson.forEach((field: any) => {
    //   if (this.taskDetails.documentid && !field['controlvalue'] && field.hasOwnProperty('controlvalueKey')) {
    //     if (this.dataFromAPI.hasOwnProperty(field['controlvalueKey'])) {
    //       this._customForm.controls[field['controlName']].setValue(this.dataFromAPI[field['controlvalueKey']]);
    //     }
    //     if (this.dataFromAPI['additionalInfo'][0].hasOwnProperty(field['controlvalueKey'])) {
    //       this._customForm.controls[field['controlName']].setValue(this.dataFromAPI['additionalInfo'][0][field['controlvalueKey']]);
    //     }
    //   }
    // });
  }

  getCustomerDataByDocID(TaskId: string) {
    const postJson = {
      // documentId : documentID,
      taskId: TaskId
    };
    var taskDetail = {
      TaskId: this.taskDetails.TaskId,
      status: 'inprogress'
    }
    // getFNOLData
    this._appServices.postDataWithPromise(environment.endpoint.getFNOLDataTemplate, postJson).then(async (res: any) => {
      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: environment.endpoint.getFNOLDataTemplate,
          payLoad: postJson,
          response: {
            responseCode: res.StatusCode,
            responseMsg: res.Message,
            result: res
          },
          // executionTime: ""
        },
        taskDetails: taskDetail
      }
      this._appServices.logsActivity(
        res.StatusCode != 200
          ? this._appenum.EntityOfLogLevel.Critical
          : this._appenum.EntityOfLogLevel.Info,
        `${res.StatusCode != 200 ? 'FRONTEND_ALERT ' : ''} getFNOLDataTemplate Api Call to get FnolData Detail For TaskChecklist`,
        this.componentName, paramRequest.httpRequest, paramRequest.taskDetails, environment.endpoint.getFNOLDataTemplate);

      if (res.StatusCode == '200') {
        this.dataFromAPI = res.Data[0];
      } else {
        this._appServices.presentToast(res.Message[this._appSetting.selectedLanguage] != undefined ? res.Message[this._appSetting.selectedLanguage] : res.Message[this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.defaultLanguageSelected))]);
      }
      this._formAddValue();
    }, (err) => {
      var paramRequest = {
        httpRequest: {
          method: 'post',
          url: 'getFNOLDataTemplate',
          payLoad: postJson,
          response: {
            responseCode: err.status,
            responseMsg: err.message,
            result: err
          },
          // executionTime: ""
        },
        taskDetails: taskDetail
      }
      this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Critical, 'FRONTEND_ALERT getFNOLDataTemplate Api Call to get FnolData Detail For TaskChecklist', this.componentName, paramRequest.httpRequest, paramRequest.taskDetails);
      this._formAddValue();
    });
  }

  _formRender() {
    const _dynamicFormControls: any = {};
    this.formFieldsJson.forEach((field: any) => {
      var validation = [];
      if (field.hasOwnProperty('optionsKey')) {
        if (field['optionsKey'] == 'selectyear') {
          field['controlOptions'] = this.datalist;
        }
      }
      if (field['isRequired']) {
        validation.push(Validators.required);
      }
      if (field['inputPattern'] && field['inputPattern'] != '') {
        validation.push(Validators.pattern(field['inputPattern']))
      }
      if (field['controlType'] != 'checkbox') {
        _dynamicFormControls[field['controlName']] = new UntypedFormControl(field['controlvalue'] || '', validation);
      } else {
        const formArray: UntypedFormArray = new UntypedFormArray([]);
        for (var i = 0; i < field['controlvalue'].length; i++) {
          formArray.push(new UntypedFormControl((field['controlvalue'][i]).trim()));
        }
        _dynamicFormControls[field['controlName']] = formArray
      }
    });
    this._customForm = new UntypedFormGroup(_dynamicFormControls);

    setTimeout(() => {
      this._customForm.valueChanges.subscribe(res => {
        this._customFormSummarySubmit();
      });
    }, 100);
  }

  public ngOnDestroy() {
    if (this.valueChangeSub) {
      this.valueChangeSub.unsubscribe();
    }
  }



  async goToCustomTextArea(formData) {
    var controlName = formData.controlName;
    var obj = {
      component: CustomTextareaComponent,
      cssClass: 'my-custom-class1',
      componentProps: { value: formData.controlvalue, label: formData.label[this._appSetting.selectedLanguage] }
    }
    let modal = await this.modalCtrl.create(obj);

    modal.present();
    const additionalData = await modal.onWillDismiss();
    if (additionalData && additionalData.data.data != undefined) {
      this._customForm.get(controlName).patchValue(additionalData.data.data)
    }

  }
  onCheckChange(event: any, controlName: any) {
    const formArray: UntypedFormArray = this._customForm.get(controlName) as UntypedFormArray;
    if (event.target.checked) {
      formArray.push(new UntypedFormControl((event.target.value).trim()));
    } else {
      let i: number = 0;
      formArray.controls.forEach((ctrl) => {
        if (ctrl.value == ((event.target.value).trim())) {
          formArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  _customFormSummarySubmit() {
    if (this.formFieldsJson?.length > 0) {
      if (!this._customForm.valid) {
        Object.keys(this._customForm.controls).forEach(field => {
          const control: any = this._customForm.get(field);
          control.markAsTouched({ onlySelf: true });
        });
        return;
      }

      this.zoneKeys.forEach((key: any) => {
        if (this._customForm[key].length > 0) {
          this._customForm[key][0].data.map((item: any) => {
            item.controlvalue = !Array.isArray(item['controlvalue']) ? (this._customForm.value[item.controlName]).trim() : this._customForm.value[item.controlName];
          });
        }
      });
    }
    this._tempDynamicStoreconfig.serverDataQues = this._customForm;
  }

  _customFormSubmit() {
    if (this.formFieldsJson?.length > 0) {
      this.customTaskChecklist.map(item => {
        item.controlvalue = this._customForm.value[item.controlName]
      })
    }
    this._customFormValues1.emit(this.customTaskChecklist);
  }

  async conditionChange(data) {
    this.customTaskChecklist.forEach(res => {
      if (data.controlName == res.dependentControlDetail.controlName && data.controlvalue == res.dependentControlDetail.dependentValue) {
        res.dependentControlDetail.isDependent = false;
      } else if (data.controlName == res.dependentControlDetail.controlName && data.controlvalue != res.dependentControlDetail.dependentValue) {
        this._customForm.controls[res.controlName].patchValue("");
        res.controlvalue = "";
        res.dependentControlDetail.isDependent = true;
      }
    })
    this.customTaskChecklist.map(item => {
      item.controlvalue = this._customForm.value[item.controlName]
    })
    if (this.PageName != "dynamicCard") {
      this._customFormValues1.emit(this.customTaskChecklist);
    }
  }



  ngOnChanges(changes: SimpleChanges): void {
  }


  getGpsDetails() {
    this._appServices._gpsService.checkCurrentPosition().then((resp) => {
      this.lat = resp.coords.latitude;
      this.long = resp.coords.longitude;
    }, err => {
      this.getGpsDetails();
    });
  }




  fileCapture(obj) {
    this.previewFile = false;
    this.downloadFile = false;
    this.fileobj = obj;
    var files = document.getElementById(obj.controlName)['files'];
    if (files.length == 0) {
      return;
    }

    var formData = new FormData();
    formData.append("userId", this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId)));
    formData.append("fileType", obj.controlType);
    formData.append("taskId", this.taskDetails.TaskId);
    formData.append("status", '1');
    formData.append("note", this.taskDetails.TaskId + '---' + obj.controlType);
    formData.append("metadata", '');
    formData.append("fileLat", this.lat);
    formData.append("fileLng", this.long);
    formData.append("cameraOrientation", 'NA');
    formData.append('file', files[0]);
    this._appServices.upload(environment.endpoint.fileUpload, formData).subscribe(_res => {
      if (_res.status == 'progress' && _res.message == 100) {

      } else if (_res.StatusCode == 200) {

        this.zoneKeys.forEach((key: any) => {
          if (this._customForm[key].length > 0) {
            this._customForm[key][0].data.filter((item: any) => {
              this._customForm.controls[obj.controlName].patchValue(_res.Data);
              obj.controlvalue = _res.Data;
            });
          }
        });
        this._customFormSummarySubmit();
        this.getFileList();
      }
    }, err => {
    });
  }


  documentMapFile(fileDetails) {
    var files = this.fileList.filter(file => file.serverFileName == fileDetails.fileName);
    if (files.length > 0) {
      var file = document.getElementById(this.fileobj.controlName)['files'];
      var url = URL.createObjectURL(file[0]);
      //  window.location.href = files[0].filePath;
      window.location.href = url;
      //  window.open(files[0].filePath);
    }
  }


  async getFileList() {
    var getTaskFilesPostJson = {
      "taskId": this.taskDetails.TaskId,
      "fileType": "files",
    };
    var taskDetail = {
      TaskId: this.taskDetails.TaskId,
      status: 'inprogress'
    }
      ; (await this._appServices.postData(environment.endpoint.getFile, getTaskFilesPostJson)).subscribe(_res => {
        var paramRequest = {
          httpRequest: {
            method: 'post',
            url: 'getFile',
            payLoad: getTaskFilesPostJson,
            response: {
              responseCode: _res.StatusCode,
              responseMsg: _res.Message,
              result: _res
            },
            // executionTime: ""
          },
          taskDetails: taskDetail
        }
        this._appServices.logsActivity(
          _res.StatusCode == 200
            ? 'info'
            : _res.StatusCode == 403
              ? 'warning'
              : 'error',
          'getFile Api Call', this.componentName,
          paramRequest.httpRequest, paramRequest.taskDetails,
          environment.endpoint.getFile
        );

        if (_res.StatusCode == 200) {
          this.fileList = _res.Data;
          this.previewFile = true;
          this.downloadFile = true;
        }
      }, err => {
        var paramRequest = {
          httpRequest: {
            method: 'post',
            url: 'getFile',
            payLoad: getTaskFilesPostJson,
            response: {
              responseCode: err.status,
              responseMsg: err.message,
              result: err
            },
            // executionTime: ""
          },
          taskDetails: taskDetail
        }
        this._appServices.logsActivity(this._appenum.EntityOfLogLevel.Error, 'getFile Api Call', this.componentName, paramRequest.httpRequest, paramRequest.taskDetails, environment.endpoint.getFile);
      });
  }
  isHeading(formData) {
    return formData.controlType != 'label' && formData.controlType != 'catheading' && formData.controlType != 'catsubheading';
  }

  dynamicIndent(formData) {
    if (formData.controlParent) {
      var parentStyle = document.getElementById(formData.controlParent).style.paddingLeft.split('px')[0];
      return { "padding-left": parseInt(parentStyle ? parentStyle : "0") + 15 + "px" };
    } else {
      return {};
    }
  }
  async openPreInspectionReport(myval) {
    var obj = {
      component: PreInspectionReportComponent,
      cssClass: 'my-custom-class1',
      componentProps: { instructionVal: myval.controlvalue }
    }
    let modal = await this.modalCtrl.create(obj);
    modal.present();
  }

  addnewrow(formData, tableData, i) {
    this.getTable(formData, tableData, i)
  }

  getTable(tableData, values: any, i) {
    const v = JSON.parse(JSON.stringify(values[0]));;
    var d: any = Object.values(v);
    var prefix = new Date().valueOf();
    for (let a of d[0]) {
      a.controlvalue = ''
      a.id = a.id + prefix;
    }
    this.lastKey = tableData.tableData.value.length + 1
    const addnew: any = [{
      lastKey: d[0]
    }]
    addnew.forEach(obj =>
      renameKey(obj, 'lastKey', this.lastKey)
    );
    const updatedJson = addnew;
    for (let j of this.customTaskChecklist[i].templateQues) {
      if (j.id == tableData.id) {
        j.tableData.value.push(updatedJson[0])
      }
    }

  }
  setTableCtlVal(e, obj) {
    obj[e.name] = e.value;
  }

  async removeRow(i, tableData) {
    const alert = await this._alertController.create({
      cssClass: 'Confirmation_popup regularFonts',
      header: this.confirmText,
      message: '<p class="m-b-10">' + this.deleteRowMsg + '</p>',
      buttons: [
        {
          text: this.cancelText,
          role: 'cancel',
          cssClass: ['confirmation_cancel_button', 'confirmation_popup_button'],
          handler: (blah) => {
          }
        }, {
          text: this.yesText,
          cssClass: ['confirmation_ok_button', 'confirmation_popup_button'],
          handler: () => {
            this.removeconfirmRow(i, tableData)
          }
        }
      ]
    });
    await alert.present();
  }

  removeconfirmRow(i, tableData) {
    if (i != tableData.length - 1) {
      tableData.splice(i, 1);
      let count = 0
      for (let l of tableData) {
        count++
        var key = Object.keys(l);
        var key2 = (Number(key[0]));
        if (count != key2) {
          l[count] = l[key2];
          delete l[key2];
        }
      }
    } else {
      tableData.splice(i, 1);
      let count = 0
      for (let l of tableData) {
        count++
        var key = Object.keys(l);
        var key2 = (Number(key[0]));
        l[count] = l[key2];

      }
    }
  }
  async getTableData(val, index, tableform, templateName, templateId) {
    var obj = {
      component: CustomTablevalComponent,
      cssClass: 'my-custom-class1',
      componentProps: { value: val[index + 1], }
    }
    let modal = await this.modalCtrl.create(obj);
    modal.present();
    this.tableRowvalue = await modal.onWillDismiss();
    if (this.tableRowvalue.data?.dismissed == 'save') {
      this.customTaskChecklist[0].templateQues.forEach(item => {
        if (item.controlType == 'table' && (tableform.controlName == item.controlName)) {
          item.tableData.value = tableform.tableData.value
          item.controlvalue = 'abc';
        }
      })
      if (this.PageName != "dynamicCard") {
        this.customTaskChecklist.emit(this.customTaskChecklist);
      }
    }
  }

}
function renameKey(obj, oldKey, newKey) {
  obj[newKey] = obj[oldKey];
  delete obj[oldKey];
}